import Notification from 'element-ui/lib/notification';
import axios from 'axios';
import Vue from 'vue';
import qs from 'qs';
import * as Sentry from '@sentry/browser';

export const http = axios.create({
  baseURL: process.env.VUE_APP_API,
  timeout: 30000,
  withCredentials: true
});

function isNewReturnType(data) {
  let keys = Object.keys(data);
  if (keys.length !== 3) return false;
  return ['code', 'data', 'msg'].every(e => keys.includes(e));
}

// 添加请求拦截器
http.interceptors.request.use(function (config) {
  try {
    let data = JSON.parse(window.localStorage.getItem('user'));
    let u = {
      'username': data.userName,
      'id': data.userId
    }
    Sentry.setUser(u);
  } catch (e) {
  }
  if (config.method === 'get') {
    config.paramsSerializer = params => {
      return qs.stringify(params, {indices: false});
    };
  }
  return config;
});

http.interceptors.response.use(response => {
  if (isNewReturnType(response.data)) {
    switch (response.data.code) {
      case 200 :
        return response.data;
      case 401:
        window.location.href = '#' + window.ENTRANCE;
        window.location.reload();
        return Promise.reject({response});
      case 403:
        Notification.error({
          message: '您没有权限请求信息，请联系管理员。',
          onClose: function () {
            window.localStorage.removeItem('noticeError');
          }
        });
        return Promise.reject({response});
      case 400:
        return Promise.reject({response});
      default:
        return Promise.reject({response});
    }
  } else {
    return response;
  }
}, error => {
  let noticeTipKey = 'noticeError';
  let notice = window.localStorage.getItem(noticeTipKey);
  let response = error.response;

  if (notice === '1' && response && response.status !== 401) {
    return Promise.reject(error);
  } else {
    window.localStorage.setItem(noticeTipKey, '1');
  }
  if (!response || response.status === 500) {
    Notification.warning({
      message: '网络服务异常, 请重试',
      onClose: function () {
        window.localStorage.removeItem(noticeTipKey);
      }
    });
    return Promise.reject(error);
  }
  if (response.status === 401) { //  Unauthorized, redirect to login
    let lastUrl = window.localStorage.getItem('lastUrl');
    if (!lastUrl || lastUrl.indexOf('/base/dict') === -1) {
    }
    window.location.href = '#' + window.ENTRANCE;
    window.location.reload();
    return Promise.reject(error);
  }
  if (response.status === 403) {
    Notification.error({
      message: '您没有权限请求信息，请联系管理员。',
      onClose: function () {
        window.localStorage.removeItem(noticeTipKey);
      }
    });
  }

  if (response.status === 502) {
    Notification.error({
      message: '系统请求失败',
      onClose: function () {
        window.localStorage.removeItem(noticeTipKey);
      }
    });
  }
  return Promise.reject(error);
});

Vue.prototype.$http = http;


// bsp待验库存
export const BspConfirmInventory = resource('/bsp-check-stock/org', http, {
  save(obj) {
    return http.put('/bsp-check-stock/adjust', obj);
  },
  queryLog(params) {
    return http.get(`/bsp-check-stock/${params.stockBatchId}/log`, {params})
  }
});

// bsp上报库存
export const BspInventory = resource('/bsp-inventory-stock', http, {
  save(obj) {
    return http.put('/bsp-inventory-stock/adjust/all', obj);
  },
  queryLog(params) {
    return http.get('/bsp-inventory-stock/adjust/log', {params})
  }
});

// bsp仓库
export const BspWarehouse = resource('bsp-warehouse', http, {
  queryList(params) {
    return http.post('/bsp-warehouse/list', params)
  }
});

// bsp物流中心
export const BspLogistics = resource('bsp-logistics', http, {
  queryCurLogistics(params) {
    return http.get('/bsp-logistics/register', {params});
  },
  put(obj) {
    return http.post('/bsp-logistics', obj);
  },
  delete(obj) {
    return http.delete('/bsp-logistics', {
      data: obj
    });
  }
});

// 追溯码
export const traceCode = {
  addCode(productSubclassId, params) {
    return http.post(`/code-apply-task/apply?productSubclassId=${productSubclassId}`, params)
  },
  queryAllList(params, pageNo, pageSize) {
    return http.post(`code-apply-task/regulatory/pager?pageNo=${pageNo}&pageSize=${pageSize}`, params)
  },
  queryList(params, pageNo, pageSize) {
    return http.post(`/code-apply-task/pager?pageNo=${pageNo}&pageSize=${pageSize}`, params)
  },
  getInfo(id) {
    return http.get(`/code-apply-task/${id}`);
  },
  queryCode(params) {
    return http.post(`/code-apply-task/list`, params)
  },
  download(taskId) {
    return http.get(`/code-apply-task/download?taskId=${taskId}`)
  },
  downloadComplete(taskId) {
    return http.get(`/code-apply-task/download/complete?taskId=${taskId}`)
  },
  getReplaceInfo(id) {
    return http.get(`/code-replace-task/${id}`)
  },
  addReplace(list) {
    return http.post(`/code-replace-task`, list)
  },
  getOrgList(params, pageNo, pageSize) {
    return http.post(`/code-replace-task/org/pager?pageNo=${pageNo}&pageSize=${pageSize}`, params)
  },
  getAllList(params, pageNo, pageSize) {
    return http.post(`/code-replace-task/regulatory/pager?pageNo=${pageNo}&pageSize=${pageSize}`, params)
  },
  getCancelInfo(id) {
    return http.get(`/code-cancellation-task/${id}`)
  },
  addCancel(list) {
    return http.post(`/code-cancellation-task`, list)
  },
  getCancelList(params, pageNo, pageSize) {
    return http.post(`/code-cancellation-task/org/pager?pageNo=${pageNo}&pageSize=${pageSize}`, params)
  },
  getAllCancelList(params, pageNo, pageSize) {
    return http.post(`/code-cancellation-task/regulatory/pager?pageNo=${pageNo}&pageSize=${pageSize}`, params)
  },
  relatedDelete(params, pageNo, pageSize) {
    return http.post(`/code-delete-task/org/pager?pageNo=${pageNo}&pageSize=${pageSize}`, params)
  },
  relatedOrgDelete(params, pageNo, pageSize) {
    return http.post(`/code-delete-task/regulatory/pager?pageNo=${pageNo}&pageSize=${pageSize}`, params)
  },
  getDeleteInfo(id) {
    return http.get(`/code-delete-task/${id}`)
  },
  getDeleteGoodsInfo(key) {
    return http.get(`/code-source/${key}`)
  }
}

// 产品子类管理
export const goodsManage = {
  orgGoodsQuery(params, pageNo, pageSize) {
    return http.post(`/product-subclass/pager/org?pageNo=${pageNo}&pageSize=${pageSize}`, params)
  },
  allGoodsQuery(params, pageNo, pageSize) {
    return http.post(`/product-subclass/pager?pageNo=${pageNo}&pageSize=${pageSize}`, params)
  },
  goodsAdd(params) {
    return http.post(`/product-subclass`, params)
  },
  goodsEdit(params) {
    return http.put(`/product-subclass`, params)
  },
  goodsDelete(key) {
    return http.delete(`/product-subclass/${key}`)
  }
}

// 资源码
export const resourceCode = {
  queryCode(params) {
    return http.post(`/resource-code/list`, params)
  },
  addCode(params) {
    return http.post(`/resource-code`, params)
  },
  editCode(params) {
    return http.put(`/resource-code`, params)
  },
  deleteCode(key) {
    return http.delete(`/resource-code/${key}`)
  }
}

// 新数据字典组对象
export const dhsDictGroup = resource('dhsDictGroup', http, {
  dosageForm() {
    return this.$getDhsDict('dosageForm')
  }
})

//业务单位
export const businessOrg = {
  queryOrg(orgId) {
    return http.post(`/dhs-business-org/${orgId}/unbound-org`, {});
  },
  save(obj) {
    return http.post('/dhs-business-org/insert', obj);
  },
  query(params) {
    return http.post('/dhs-business-org/pager', params);
  },
  audit(id) {
    return http.post(`/dhs-business-org/start/${id}`, {});
  },
  disabled(id) {
    return http.post(`/dhs-business-org/disable/${id}`, {});
  },
  delete(id) {
    return http.delete(`/dhs-business-org/${id}`,);
  },
  queryPager(params) {
    return http.post('dhs-business-org/list', params);
  }
};

// 实物追溯
export const physicalGoodsSearch = {
  save(obj) {
    return http.post('/code-physical-trace/task/latest', obj);
  },
  query(params) {
    return http.get('/code-physical-trace/task/pager', {params});
  },
  queryBaseInfo(id) {
    return http.get(`/code-physical-trace/task/${id}`);
  },
  queryAreaTree(bizTypeId) {
    return http.get(`/code-physical-trace/task/${bizTypeId}/tree`);
  },
  queryAreaDetail(areaId, params) {
    return http.get(`/code-physical-trace/task/${areaId}/detail`, {params});
  },
  queryPerson(params) {
    return http.get('/code-physical-trace/user/task/pager', {params});
  }
};

// bsp库存
export const BspStock = resource('/bsp-stock', http, {
  queryOrgStock(params) {
    return http.get('/bsp-stock/org', {params});
  },
  queryOrgStockList(params) {
    return http.get('/bsp-stock/list', {params});
  },
  queryStockDetail(id) {
    return http.get(`/bsp-stock/${id}/detail`);
  },
  queryBatchStock(params) {
    return http.get('/bsp-stock/batch', {params});
  },
  queryOrgBatchStock(params) {
    return http.get('/bsp-stock/batch/org', {params});
  },
  queryOrgStoreFlow(params) {
    return http.get('/bsp-stock/org/operating-goods', {params});
  }
});

// 货品管理
export const DhsGoods = resource('/dhs-goods', http, {
  queryPager(obj) {
    return http(
      {
        method: 'post',
        url: '/dhs-goods/base-info-pager',
        data: obj
      });
  }
});

// dhs仓库地址
export const dhsAddress = resource('/dhs-orgAddressInfo', http, {
  queryAddress: (id, params) => {
    return http.get('/dhs-orgAddressInfo/list', {params});
  },
  updateAddress: function (obj) {
    return http.put('/dhs-orgAddressInfo', obj);
  },
  check: (id, obj) => {
    return http.put('/dhs-orgAddressInfo/' + id + '/check', obj);
  },
  forbid: function (id) {
    return http.put('/dhs-orgAddressInfo/' + id + '/forbid', {});
  },
  bizForbid: function (id) {
    return http.put('/dhs-orgAddressInfo/' + id + '/bizForbid', {});
  },
  start: function (id) {
    return http.put('/dhs-orgAddressInfo/' + id + '/start', {});
  },
  auditInfo: (id, obj) => {
    return http.put('/dhs-orgAddressInfo/orgs/' + id + '/check', obj);
  },
  queryStateNum: (params) => {
    return http.get('/dhs-orgAddressInfo/count', {params});
  }
});

export const BSPOrder = resource('/bsp-order', http, {
  queryStateNum: function (params) {
    return http.get('/bsp-order/count/', {params});
  },
  queryOrgOrder(params) {
    return http.get('/bsp-order/org', {params});
  },
  queryOrgStateSum(params) {
    return http.get('/bsp-order/org/count', {params});
  },
  queryGoodsList(params) {
    return http.get('/bsp-receipt', {params});
  },
  queryOutGoodsList(params) {
    return http.get('/bsp-order/out/detail', {params});
  },
  queryOrgGoodsList(params) {
    return http.get('/bsp-receipt/org', {params});
  },
  queryOutOrgGoodsList(params) {
    return http.get('/bsp-order/out/detail/org', {params});
  },
  queryReceiptDetail(id) {
    return http.get(`/bsp-receipt/${id}`);
  },
  queryNeedOrder(params) {
    return http.get('/bsp-order/org/required', {params});
  },
  queryPurchaseOrder(params) {
    return http.get('/bsp-order/org/procurement-return', {params});
  },
  addLogisticsOrder(obj) {
    return http.post('/bsp-order/logistics', obj);
  },
  batchConfirmOrder: (obj) => {// 确认订单
    return http.post('/bsp-order/batchConfirm', obj);
  },
  queryLogisticsOrder(params) {
    return http.get('/bsp-order/logistics', {params});
  },
  queryLogisticsOrderCount(params) {
    return http.get('/bsp-order/logistics/count', {params});
  }
});

// 追溯权限分配
export const traceRight = {
  save(obj) {
    return http.post('/code-access/self', obj);
  },
  query(params) {
    return http.post('/code-access/pager', params);
  },
  delete(key) {
    return http.delete(`/code-access/${key}`);
  }
};

// 电子监管码
export const electronCode = resource('/code-rule', http, {
  query(params) {
    return http.post('/code-rule/pager', params);
  },
  update(obj) {
    return http.post('/code-rule/edit', obj);
  }
});


// 经营货品
export const OperatingGoods = resource('dhs-operation-goods', http, {
  queryUnboundListByOrgId: (orgId, params) => {
    return http.get('dhs-operation-goods/org/' + orgId + '/unbound', {params});
  },
  save(obj) {
    return http.post('/dhs-operation-goods/factory', obj);
  },
  auditGoods(obj) {
    return http.post('/dhs-operation-goods/audit', obj);
  }
});


// oms附件对象
export const OmsAttachment = resource('omsAttachment', http, {
  queryOneAttachmentList: (objectId, objectType) => {
    return http.get('/omsAttachment/' + objectType + '/' + objectId, {});
  }

});

// 推送地址管理
export const PushCode = resource('/code-push-address', http);

// 业务追溯
export const bizTraces = resource('/code-biz', http, {
  queryByPlateNumber(params) {
    return http.get('/code-biz/batch-number', {params});
  },
  queryPlateNumberTask(params) {
    return http.get('/code-biz/batch-task/pager', {params});
  },
  queryPlateNumberDetail(detailId, params) {
    return http.get(`/code-biz/batch-number/${detailId}/code`, {params});
  },
  queryTraceCodes(logId, params) {
    return http.get(`/code-biz/${logId}/trace-detail`, {params});
  },
  queryPerson(params) {
    return http.get('/code-biz/batch-task/user/pager', {params});
  },
  queryInOrder(params){
    return http.get('code-biz/in-order', {params});
  },
  queryOutOrder(params){
    return http.get('code-biz/out-order', {params});
  },
  refreshOrder(orderId){
    return http.get(`/code-biz/detail/refresh?bizLogId=${orderId}`, {});
  }
});

// 单只追溯查询
export const SingleLog = resource('/code-access-log', http, {});

// 上传记录
export const UploadLog = resource('/code-upload', http, {});

// 系统日志
export const SystemLog = resource('/code-system-log', http, {});

// 证照对象
// 证照对象
export const orgLicence = resource('/dhs-order-licence', http, {
  queryPager: (params) => {
    return http.get('/dhs-order-licence/page', {params});
  },
  queryStateNum: (params) => {
    return http.get('/dhs-order-licence/count', {params});
  }
});

// 合同对象
export const Contract = resource('contract', http, {
  forbid: (id) => {
    return http.put('contract/' + id + '/forbid', {});
  },
  start: (id) => {
    return http.put('contract/' + id + '/start', {});
  },
  check: (id, obj) => {
    return http.put('contract/' + id + '/check', obj);
  },
  queryStateNum: (params) => {
    return http.get('/contract/count', {params});
  }
});

// 疾控中心合同对象
export const CusContract = resource('cusContract', http, {
  queryPager: (orgId, params) => {
    return http.get('/cusContract/' + orgId, {params});
  },
  forbid: (id) => {
    return http.put('cusContract/' + id + '/forbid', {});
  },
  start: (id) => {
    return http.put('cusContract/' + id + '/start', {});
  },
  check: (id, obj) => {
    return http.put('cusContract/' + id + '/check', obj);
  },
  queryStateNum: (params) => {
    return http.get('/cusContract/count', {params});
  }
});

// 疾控中心银行对象
export const CusBankInfo = resource('cusBankInfo', http, {
  queryList: (orgId, params) => {
    return http.get('/cusBankInfo/' + orgId, {params});
  },
  check: (id, obj) => {
    return http.put('cusBankInfo/' + id + '/check', obj);
  },
  auditInfo: (id, obj) => {
    return http.put('cusBankInfo/orgs/' + id + '/check', obj);
  },
  forbid: (id) => {
    return http.put('cusBankInfo/' + id + '/forbid', {});
  },
  start: (id) => {
    return http.put('cusBankInfo/' + id + '/start', {});
  },
  queryStateNum: (params) => {
    return http.get('/cusBankInfo/count', {params});
  }
});

// 物流中心对象
export const LogisticsCenter = resource('logisticsCenter', http, {
  start: (id) => {
    return http.put('/logisticsCenter/' + id + '/start', {});
  },
  forbid: (id) => {
    return http.put('/logisticsCenter/' + id + '/forbid', {});
  },
  queryStateNum: (params) => {
    return http.get('/logisticsCenter/count', {params});
  }
});

// 计费项目对象
export const CostItem = resource('costItem', http, {});

// 质量异常类型对象
export const QualityExceptionType = resource('qualityExceptionType', http, {
  start: (id) => {
    return http.put('/qualityExceptionType/' + id + '/start', {});
  },
  forbid: (id) => {
    return http.put('/qualityExceptionType/' + id + '/forbid', {});
  },
  queryStateNum: (params) => {
    return http.get('/qualityExceptionType/count', {params});
  },
  querylinkException: function (params) {
    return http.get('/qualityExceptionType/link', {params});
  }
});

// 入库质量检查方案
export const QualityProgramme = resource('qualityProgramme', http, {
  getList: (orgId => {
    return http.get('qualityProgramme/' + orgId, {
      params: {deleteFlag: false}
    });
  }),
  getRow: (id => {
    return http.get('qualityProgramme/detail', {
      params: {
        id: id
      }
    });
  })
});

// 质量检查项目对象
export const QualityItem = resource('qualityItem', http, {
  queryList: () => {
    return http.get('/qualityItem/list', {
      params: {deleteFlag: false, status: '1'}
    });
  },
  start: (id) => {
    return http.put('/qualityItem/' + id + '/start', {});
  },
  forbid: (id) => {
    return http.put('/qualityItem/' + id + '/forbid', {});
  },
  queryStateNum: (params) => {
    return http.get('/qualityItem/count', {params});
  }
});

// 受控法规对象
export const ControlledLegislation = resource('controlledLegislation', http, {
  start: (id) => {
    return http.put('/controlledLegislation/' + id + '/start', {});
  },
  forbid: (id) => {
    return http.put('/controlledLegislation/' + id + '/forbid', {});
  },
  queryStateNum: (params) => {
    return http.get('/controlledLegislation/count', {params});
  }
});

// 设备资料对象
export const Dev = resource('oms-dev', http, {});

// 数据字典组对象
export const DictGroup = resource('dictGroup', http, {
  checkGroupName: (groupName, groupId) => {
    return http.get('/dictGroup/name', {
      params: {groupName: groupName, groupId: groupId}
    });
  },
  checkItemKey: (key, itemId, groupId) => {
    return http.get('/dictItem/key', {
      params: {key: key, itemId: itemId, groupId: groupId}
    });
  },
  getAll: () => {
    return new Promise((resolve) => {
      http.get('/dictGroups').then(res => {
        let data = {};
        let groupItem;
        let item;
        for (let i = 0, len = res.data.length; i < len; i++) {
          groupItem = res.data[i];
          data[groupItem.group.name] = [];
          for (let j = 0, len1 = groupItem.items.length; j < len1; j++) {
            item = groupItem.items[j];
            data[groupItem.group.name].push({key: item.key, label: item.label});
          }
        }
        resolve(data);
      });
    });
  }
});

// 财务信息对象
export const Finance = resource('org-finance', http, {
  queryInfo: (orgId) => {
    return http.get('/org-finance/orgs/' + orgId, {});
  },
  check: (id, obj) => {
    return http.put('/org-finance/' + id + '/check', obj);
  }
});

// 数据字典项对象
export const DictItem = resource('dictItem', http, {});

// 受控法规对象
export const Material = resource('material', http, {});

// 部门对象
export const Department = resource('/department', http, {
  getPage: (params) => {
    return http.get('/department/page', {params});
  },
  getOnesMember: (id, params) => {
    return http.get('/department/' + id + '/member', {params});
  },
  getMembers: (params) => {
    return http.get('/department/members', {params});
  },
  queryStateNum: (params) => {
    return http.get('//department/member/count', {params});
  }
});

// 对象字段编号记录对象
export const pojoLog = resource('/pojo-log', http, {
  queryPojoLog: (objId, objType) => {
    return http.get('/pojo-log/type/' + objType + '/id/' + objId, {});
  }
});

// 平台用户权限对象
export const User = resource('/dhs/user', http, {
  checkEmail: (email, userId, orgId) => {
    return http.get('/dhs/user/email', {
      params: {email: email, userId: userId, orgId: orgId}
    });
  },
  checkPhone: (phone, userId, orgId) => {
    return http.get('/dhs/user/phone', {
      params: {phone: phone, userId: userId, orgId: orgId}
    });
  },
  checkCustomAccount: (account, userId, orgId) => {
    return http.get('/dhs/user/customAccount', {
      params: {customAccount: account, userId: userId, orgId: orgId}
    });
  },
  resetPsw: (Obj) => {
    return http.put('/dhs/user/password', Obj);
  },
  forget: (obj) => {
    return http.post('/dhs/user/password/verifyMail', obj);
  },
  stopUser: (userId) => {
    return http.put(`/dhs/user/${userId}/stop`);
  },
  enableUser: (userId) => {
    return http.put(`/dhs/user/${userId}/enablement`);
  }
});
// 疾控中心用户权限对象
export const OrgUser = resource('/dhs/user/org', http, {
  queryOrgInfo: (id, params) => {
    return http.get('/dhs/user/org/' + id, {params});
  },
  queryUsers: (id, params) => {
    return http.get('/dhs/user/org/' + id, {params});
  },
  updateOrgUser: (id, params) => {
    return http.put('/dhs/user/org/' + id, params);
  }
});
// 角色管理对象
export const Access = resource('/oms/access', http, {
  getRoleMenus: () => {
    return http.get('/oms/access/menus/tree', {params: {objectId: 'bsp-system'}});
  },
  getOrgRoleMenus: (orgId) => {
    return http.get('/dhs/user/org/' + orgId + '/admin/menus/tree');
  },
  getOrgRoleList: (orgId, params) => {
    return http.get('/oms/access/org/' + orgId + '/role', {params});
  },
  getOrgRole: (orgId, params) => {
    return http.get('/dhs-account/access/orgs/' + orgId, {params});
  },
  getOrgRoleSelf: (orgId, params) => {
    return http.get('/dhs-account/org/self-role', {params});
  },
  getRoleDetail: (roleId) => {
    return http.get('/oms/access/' + roleId);
  },
  bandOrgRole: (obj) => {
    return http.post('/oms/access/bind/role', obj);
  },
  queryStateNum: (orgId, params) => {
    return http.get(`/dhs-account/access/org/${orgId}/count`, {params});
  },
  deleteBandingRole: (id) => {
    return http.delete('/oms/access/unbind/role/' + id, {});
  },
  addApiAccess: (params) => {
    return http.post('/oms/access/org', params);
  },
  queryApiAccess: (params) => {
    return http.get('/oms/access/org', {params});
  }
});

// 货品管理
export const Goods = resource('/dhs-goods', http, {
  importExcelToAddplatformGoods: (params) => {
    return http.post('/dhs-goods/import', params);
  },
  importExcelToAddorgGoods: (params) => {
    return http.post('/dhs-orgs/importDhsOrgsByExcel', params);
  },
  mergeGoodsInfo: (id, params) => {
    return http.put('/dhs-goods/' + id + '/synchronization', params);
  },
  filterOrg: (orgId, params) => {
    return http.get('/dhs-goods/orgs/' + orgId, {params});
  },
  check: (id, obj) => {
    return http.put('/dhs-goods/' + id + '/check', obj);
  },
  getGoodsDetail: (id) => {
    return http.get('/dhs-goods/' + id);
  },
  queryStateNum: (params) => {
    return http.get('/dhs-goods/count', {params});
  },
  checkCode: (params) => {
    return http.get('/dhs-goods/check/code', {params});
  },
  checkGoodsCode: (params) => {
    return http.get('/dhs-goods/check/goodsCode', {params});
  },
  queryPagerByApprovalNumberDate: (params) => {
    return http.get('/dhs-goods/approvalNOValidity', {params});
  },
  queryPagerNumberByApprovalNumberDate: (params) => {
    return http.get('/dhs-goods/approvalNOValidity/count', {params});
  }
});

// 审核对象
export const Audit = resource('/audit', http, {
  // 查询某一疾控中心的当前审核流程信息
  queryAuditStatus: (orgId) => {
    return http.get('/audit/orgs/' + orgId, {});
  }
});

// 货主-基本信息
export const BaseInfo = resource('/dhs-orgs', http, {
  // 根据单位机构关系类型列表分页查询单位信息
  queryByOrgRelationTypeList: (params) => {
    return http({
      url: '/dhs-orgs/relationType',
      params,
      paramsSerializer(params) {
        return qs.stringify(params, {indices: false});
      }
    });
  },
  // 查询数量
  queryStateNum: (params) => {
    return http.get('/dhs-orgs/count', {params});
  },
  // 货主基本信息
  queryBaseInfo: (orgid) => {
    return http.get('/dhs-orgs/' + orgid);
  },
  queryPager(params) {
    return http.get('/dhs-orgs/pager', {params});
  },
  // 转成货主
  turnToOwner: (orgId) => {
    return http.put('/dhs-orgs/transform/consignor/' + orgId, {});
  },
  // 一键审核单位基础信息(同时审核单位基本信息、经营范围、执照信息,并审核基础信息模块)
  auditBaseInfo: (orgId, obj) => {
    return http.put('/dhs-orgs/' + orgId + '/check', obj);
  },
  noPassBaseInfo: (orgId, obj) => {
    return http.put('/dhs-orgs/' + orgId + '/reject-check', obj);
  },
  // 根据业务关系查询相关的单位
  queryOrgByReation: (orgId, obj) => {
    return http.get('/dhs-orgs/' + orgId + '/relation/', {params: obj});
  },
  // 根据业务关系查询相关的单位
  queryOrgByValidReation: (orgId, obj) => {
    return http.get('/dhs-orgs/' + orgId + '/valid-relation/', {params: obj});
  },
  // 校验邮箱
  checkEmail: (email, userId) => {
    return http.get('/dhs-oms/user/email', {
      params: {email: email, userId: userId}
    });
  },
  // 校验名字
  checkName: (name, orgId) => {
    return http.post('/dhs-orgs/name', {name, orgId});
  },
  // 校验身份证
  checkCreditCode: (creditCode, orgId) => {
    return http.get('/dhs-orgs/creditCode', {
      params: {creditCode, orgId}
    });
  },
  // 校验oms代码唯一性
  checkManufacturerCode: (code, orgId) => {
    return http.get('/dhs-orgs/manufacturerCode', {
      params: {code, orgId}
    });
  },
  // 校验管理员账户唯一性
  checkAdminAccount: (account, orgId) => {
    return http.get('/dhs-orgs/account', {
      params: {account, orgId}
    });
  }
});

// 业务关系
export const bizRelation = resource('/bizRelation', http, {
  queryRelationorg: (id) => {
    return http.get('/bizRelation/' + id, {});
  },
  check: (id, obj) => {
    return http.put('bizRelation/' + id + '/check', obj);
  },
  queryStateNum: (params) => {
    return http.get('/bizRelation/count', {params});
  }
});
// 疾控中心货品
export const OrgGoods = resource('/org/goods', http, {
  queryOneGoods: (id) => {
    return http.get('/orgs/goods/' + id, {});
  },
  check: (id, obj) => {
    return http.put('/org/goods/' + id + '/check', obj);
  },
  queryStateNum: (params) => {
    return http.get('/org/goods/count', {params});
  }
});
// 仓库地址
export const Address = resource('/orgAddressInfo', http, {
  queryAddress: (id, params) => {
    return http.get('/orgAddressInfo/' + id, {params});
  },
  updateAddress: function (obj) {
    return http.put('/orgAddressInfo', obj);
  },
  check: (id, obj) => {
    return http.put('/orgAddressInfo/' + id + '/check', obj);
  },
  forbid: function (id) {
    return http.put('/orgAddressInfo/' + id + '/forbid', {});
  },
  bizForbid: function (id) {
    return http.put('/orgAddressInfo/' + id + '/bizForbid', {});
  },
  start: function (id) {
    return http.put('/orgAddressInfo/' + id + '/start', {});
  },
  auditInfo: (id, obj) => {
    return http.put('/orgAddressInfo/orgs/' + id + '/check', obj);
  },
  queryStateNum: (params) => {
    return http.get('/orgAddressInfo/count', {params});
  }
});
// 计费方案
export const Case = resource('/org/costItem', http, {
  check: (id, obj) => {
    return http.put('/org/costItem/' + id + '/check', obj);
  },
  queryStateNum: (params) => {
    return http.get('/org/costItem/count', {params});
  }
});
// 订单
export const Order = resource('/order', http, {
  check: (orderId, obj) => {
    return http.put('order/' + orderId + '/check', obj);
  },

  confirmOrder: (orderId) => {// 确认订单
    return http.put('/order-status/' + orderId + '/confirm');
  },

  cancelOrder: (orderId, obj) => {// 取消订单
    return http.put('/order-status/' + orderId + '/cancel', obj);
  },

  // 订单
  examineOrder: (orderId, obj) => {// 审单
    return http.put('/order-status/' + orderId + '/examine', obj);
  },
  receiptOrder: (orderId) => {// 确认收货
    return http.put('/order-status/' + orderId + '/receipt');
  },
  acceptanceOrder: (orderId) => {// 验收通过
    return http.put('/order-status/' + orderId + '/acceptance');
  },
  rejectionOrder: (orderId, obj) => {// 拒收
    return http.put('/order-status/' + orderId + '/rejection', obj);
  },

  rejectionReviewOrder: (orderId, obj) => {// 确认复核
    return http.put('/order-status/' + orderId + '/rejection-review/reject', obj);
  },
  terminationRejection: (orderId, obj) => {// 中止拒收
    return http.put('/order-status/' + orderId + '/rejection-review/stop', obj);
  },
  agreementReceiptOrder: (orderId, obj) => {// 取消拒收
    return http.put('/order-status/' + orderId + '/check-receipt', obj);
  },
  affirmRejectionOrder: (orderId, obj) => {// 确认拒收
    return http.put('/order-status/' + orderId + '/check-rejection', obj);
  },
  stockOrder: (orderId) => {// 货品上架
    return http.put('/order-status/' + orderId + '/stock');
  },
  // 出库单
  pickingOutOrder: (orderId) => {// 货品下架
    return http.put('/order-status/' + orderId + '/picking-out');
  },
  generationOrder: (orderId) => {// 生成出库单
    return http.put('/order-status/' + orderId + '/generation');
  },
  packageOrder: (orderId) => {// 出库单打包
    return http.put('/order-status/' + orderId + '/package');
  },
  outgoingCompletedOrder: (orderId) => {// 确认出库
    return http.put('/order-status/' + orderId + '/outgoing-completed');
  },
  distributionOrder: (orderId) => {// 确认配送
    return http.put('/order-status/' + orderId + '/distribution');
  },
  signOrder: (orderId) => {// 客户签收
    return http.put('/order-status/' + orderId + '/sign');
  },
  // 查询异常
  queryOrderExcepiton: (params) => {
    return http.get('/order/quality-exception', {params});
  },
  queryStateNum: function (params) {
    return http.get('/order/count/', {params});
  },
  deleteRelation (id) {
    return http.delete(`/code-upload/relation-code/${id}`)
  }
});

// 异常管理
export const QualityException = resource('/quality-exception', http, {});

export const Dict = resource('dict', http, {
  byCode: (code) => http.get(`dict/bycode?code=${code}`)
});

export const Auth = {
  checkLogin: () => {
    return http.get('/dhs/userinfo');
  },
  secondaryCertificateLogin: (data) => {
    return http.post('/dhs/secondaryCertificate/login', data);
  },
  login: (data) => {
    return http.post('/dhs/login', data);
  },
  // 短信登录接口：/login/phone
  loginByPhone: (data) => {
    return http.post('/login/phone', data);
  },
  logout: () => {
    return http.get('/dhs/logout');
  },
  isLogin() {
    try {
      return User.current();
    } catch (e) {
      Notification.error('用户信息出错，请重新登录!');
    }
  },
  permission: () => {
    return http.get('/dhs-account/permissions', {params: {objectId: 'bsp-system'}});
  }
};

/**
 * create vue-resource's resource like object
 *
 * Default Actions
 *   get: {method: 'GET'}
 *   save: {method: 'POST'}
 *   query: {method: 'GET'}
 *   update: {method: 'PUT'}
 *   delete: {method: 'DELETE'}
 *
 * @param path the resource path
 * @param http axios instance
 * @param actions custom actions
 * @returns the resource object
 */
function resource(path, http, actions) {
  let obj = {
    get: id => http.get(path + '/' + id),
    save: obj => http.post(path, obj),
    query: params => http.get(path, {params}),
    update: (id, obj) => {
      let url = path + '/' + id;
      if (typeof (id) === 'object') {
        url = path;
        obj = id;
      }
      return http.put(url, obj);
    },
    delete: id => http.delete(path + '/' + id)
  };
  return Object.assign(obj, actions);
}
